import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchSimilarLocationListings } from '../ListingPage.duck';
/**
 * Custom hook to fetch similar location listings based on origin param provided.
 */
export const useSimilarOriginListingsRequest = (params = {}) => {
    const dispatch = useDispatch();

    const origin = params.origin;

    const request = params => dispatch(fetchSimilarLocationListings(params));

    useEffect(() => {
        if (origin) request(params);
    }, [origin]);
};
